import type { SVGProps } from 'react';
const SvgSubtitles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#subtitles_svg__a)">
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2ZM4 12h4v2H4v-2Zm10 6H4v-2h10v2Zm6 0h-4v-2h4v2Zm0-4H10v-2h10v2Z"
      />
    </g>
    <defs>
      <clipPath id="subtitles_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSubtitles;
